import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-videos',
  templateUrl: './intro-videos.component.html',
  styleUrls: ['./intro-videos.component.css']
})
export class IntroVideosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
